import React from 'react';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/themes/light.css';
import 'tippy.js/dist/themes/google.css';
import 'tippy.js/dist/themes/light-border.css';
import 'tippy.js/dist/themes/translucent.css';

// `performance: true` disables data-tippy-* attributes as they are unnecessary
// in React and slow down initialization.
Tippy.defaultProps = {
  performance: true,
  theme: 'light'
};

export const Tooltip = ({ children, ...rest }) => (
    <Tippy {...rest}>{children}</Tippy>
  );
  Tooltip.defaultProps = {
    performance: true,
    animation: 'fade',
    arrow: false,
    delay: [250,0],
    theme: 'light-border'
  };
  
  export const Popover = ({ children, ...rest }) => (
    <Tippy {...rest}>{children}</Tippy>
  );
  Popover.defaultProps = {
    performance: true,
    animateFill: false,
    animation: 'scale',
    interactive: true,
    interactiveBorder: 10,
    theme: 'light-border',
    trigger: 'click'
  };
  

export default Tippy;



// WEBPACK FOOTER //
// ./src/components/Tippy/index.js